import { GOST_2_105 } from './ids';
import type { Profile } from './types';

/**
 * ГОСТ Р 2.105-2019 «ЕСКД. Общие требования к текстовым документам».
 * Основа методичек технических вузов для пояснительных записок.
 *
 * Поля стандарт задаёт через рамку (не ближе 3 мм к рамке); для работ без
 * рамки проверяются типовые поля методичек — их легко поправить в профиле.
 * Выравнивание по ширине и нулевые интервалы — совет, как и в ГОСТ 7.32.
 */
export const GOST_R_2_105_2019: Profile = {
  id: GOST_2_105,
  name: 'ГОСТ Р 2.105-2019',
  description: 'ЕСКД: пояснительные записки к курсовым и дипломным проектам',
  page: {
    widthMm: 210,
    heightMm: 297,
    margins: { top: 20, bottom: 20, left: 30, right: 15 },
    toleranceMm: 1,
  },
  pageNumbers: { position: 'bottom', align: 'center', hideOnTitle: true },
  text: {
    fonts: ['Times New Roman', 'Arial'],
    minSizePt: 10,
    allowedSizesPt: [14, 13, 11],
    lineSpacing: 1.5,
    lineSpacingAlt: [2],
    firstLineIndentCm: 1.25,
    firstLineIndentMaxCm: 1.7,
    alignment: 'justify',
    spacingBeforePt: 0,
    spacingAfterPt: 0,
  },
  headings: {
    structuralCase: 'sentence',
    structuralBold: true,
    sectionAlign: 'indent',
    sectionBold: true,
    numberDot: false,
    // Начинать каждый раздел с новой страницы стандарт только рекомендует (п. 6.6.5).
    newPage: false,
    required: ['contents'],
    contentsMinPages: 24,
    tocDepth: 1,
    names: { contents: 'Содержание', references: 'Библиография' },
    order: [
      ['executors', 'abstract', 'annotation', 'preface'],
      ['contents'],
      ['abbreviations', 'terms'],
      ['intro'],
      ['conclusion'],
      ['references', 'appendix'],
    ],
  },
  captions: { dashes: ['—', '–'], numbering: 'any' },
  references: { order: 'appearance' },
  rules: {
    // Содержание — дополнительный элемент: его включают, «как правило», в документы больше 24 листов.
    'structure.required': 'warning',
    // Положение номера страницы для документов без рамки стандарт не задаёт.
    'page.numbers-position': 'off',
    'page.numbers-title': 'info',
    // Небольшие рисунки без ссылок допускается не нумеровать (п. 6.9.3).
    'objects.figure-ref': 'info',
    'objects.figure-missing': 'info',
    // «Полужирный только в заголовках» — требование ГОСТ 7.32, в ЕСКД его нет.
    'text.bold': 'off',
  },
};
